import sectionSocialCommentCss from '../css-snippets/section-social-comment';

const html = ` 
<style>${sectionSocialCommentCss}</style>
<div
  class="social-comment-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="social-comment-container container">
    <div class="social-comment-title">
      <h2>
        <strong>Comments</strong>
      </h2>
    </div>
    <textarea
      class="social-comment-textarea"
      rows="4"
      placeholder="Add a comment..."
      name="social-comment"
    ></textarea>
    <div class="comments-list">
    </div>
  </div>
</div>
`;

export default html;
